import { tourAPI } from '@/api/tourAPI';

export const addNewTour = async (categoryId: number, tourId?: number) => {
  try {
    const draftId = await tourAPI.addNew(categoryId, tourId);
    return draftId;
  } catch (error) {
    console.error(error);
  }
};
